import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { BankInfo } from '@/shared/types/global.types'

export function getBanks(token: string): Promise<BankInfo[]> {
  return apiRequest<BankInfo[]>(API_PATH.BANKS, token)
}
